<template lang="html">
  <app-modal @close="close" class="prompt">
    <app-modal-default @close="close">
      <template v-slot:header>
        {{ $ml.get(`Confirm`) }}
      </template>
      <template v-slot:content>
        <div class="content">
          <div class="text">
            {{ text }}
          </div>
          <div class="buttons">
            <app-btn styling="inline" @click="emitCancel">{{ $ml.get(`cancel`) }}</app-btn>
            <app-btn @click="emitAccept">{{ $ml.get(`Okay`) }}</app-btn>
          </div>
        </div>
      </template>
    </app-modal-default>
  </app-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {

  },
  methods: {
    emitAccept() {
      this.onAccept();
      this.close();
    },
    emitCancel() {
      this.onCancel();
      this.close();
    },
    close() {
      this.$store.commit('modals/prompt/close');
    }
  },
  computed: {
    ...mapGetters({
      text: 'modals/prompt/text',
      onAccept: 'modals/prompt/onAccept',
      onCancel: 'modals/prompt/onCancel',
    })
  },
}
</script>

<style lang="scss" scoped>

.content {

  width: 300px;

  .buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    .app-btn {
      margin-left: 10px;
    } 
  }

  .text {
    padding-bottom: 30px;
  }
  @media (max-width: 768px) {
    width: auto;
  }
}

</style>
